// import Vue from 'vue'
import axios from "axios"; // 引入axios
import qs from "qs"; // 引入qs
import router from "../router";
var host = "https://api.microapp.metalcar.cn";//正式线域名
// var host = "https://pre.metalcar.cn"; // 测试请求域名
// var host = 'http://dev.metalcar.cn' //本地请求域名
// var host = 'http://y41650t188.wicp.vip:12008' //本地请求域名

// request请求

function HZrequest(xurl, method, data, header) {
  // xurl:接口地址  methods:请求方式 data:需要发送的参数
  let headerObj = {};
  headerObj = {
    "content-type": "application/json"
  };
  let token = localStorage.getItem("token");
  if (token) {
    headerObj.Authorization = "Bearer " + token;
  }
  if (method == 'GET') {
    data = qs.stringify(data)
    xurl=xurl+"?"+data
  }
  return new Promise(function(resolve, reject) {
    axios({
      url: host + xurl,
      data: data,
      method: method,
      headers: headerObj
    })
      .then(function(res) {
        if (res.data.code === 302) {
          // 302 员工身份未激活 或过期 重新到login 绑定页面
          router.replace({
            path: "/login"
          });
        } else if (res.data.code === 401) {
          //token 过期 重新登录 重定向到首页 remove token 移除登录状态！
          localStorage.removeItem("token");
          HZrequest("/we-chat/gzh/loginUrl", "GET", null, null).then(res => {
            location.href = res;
            // location.href = 'http://localhost:1024/index.html?code=0516Uf0w3p5AWY2xcz3w3h1v8906Uf0u&state=#/';
            
            // location.href = 'http://activate.navicat.com';
          });
        }else {
          resolve(res.data);
        }
      })
      .catch(function(err) {
        reject(err.data);
      });
  });
}

// request请求(上传图片请求)
function PHrequest(xurl, method, data, headerObj) {
  // xurl:接口地址  methods:请求方式 data:需要发送的参数
  var headerObj = {};
  headerObj = {
    "content-type": "multipart/form-data"
  };
  let token = localStorage.getItem("token");
  if (token) {
    headerObj.Authorization = "Bearer " + token;
  }
  return new Promise(function (resolve, reject) {

    axios({
      url: host + xurl,
      data: data,
      method: method,
      headers: headerObj
    })
      .then(function(res) {
        if (res.data.code === 302) {
          router.push({
            path: "/login"
          });
        }
        resolve(res.data);
      })
      .catch(function(res) {
        if (typeof res.response === "undefined") {
          location.reload();
        }
        reject(res.data);
      });
  });
}

// base64转码
function dataURLtoFile(dataurl, filename) {
  // 将base64转换为文件
  // eslint-disable-next-line one-var
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
// 压缩图片
function compressImg(file) {
  var filename = file.name;
  var files;
  var fileSize = parseFloat(parseInt(file["size"]) / 1024 / 1024).toFixed(2);
  var read = new FileReader();
  read.readAsDataURL(file);
  return new Promise(function(resolve, reject) {
    read.onload = function(e) {
      var img = new Image();
      img.src = e.target.result;
      img.onload = function() {
        // 默认按比例压缩
        // eslint-disable-next-line one-var
        var w = this.width,
          h = this.height;
        // 生成canvas
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var base64;
        // 创建属性节点
        canvas.setAttribute("width", w);
        canvas.setAttribute("height", h);
        ctx.drawImage(this, 0, 0, w, h);
        if (fileSize < 1) {
          // 如果图片小于一兆 那么不执行压缩操作
          base64 = canvas.toDataURL(file["type"], 1);
        } else if (fileSize > 1 && fileSize < 2) {
          // 如果图片大于1M并且小于2M 那么压缩0.5
          base64 = canvas.toDataURL(file["type"], 0.5);
        } else {
          // 如果图片超过2m 那么压缩0.2
          base64 = canvas.toDataURL(file["type"], 0.2);
        }
        // 回调函数返回file的值
        files = dataURLtoFile(base64, filename);
        resolve(files);
      };
    };
  });
}

export default {
  host,
  HZrequest,
  compressImg,
  PHrequest
};



// WEBPACK FOOTER //
// ./src/http/api.js